import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2, Crown } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { refresh } = useAuth();
  const [state, setState] = useState("checking"); // checking | paid | failed
  const [info, setInfo] = useState(null);

  useEffect(() => {
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setInfo(data);
        if (data.payment_status === "paid") { setState("paid"); refresh?.(); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setState("failed"); return; }
      } catch { /* keep trying */ }
      if (tries++ < 8) timer = setTimeout(poll, 2000);
      else setState("failed");
    };
    if (sessionId) poll(); else setState("failed");
    return () => clearTimeout(timer);
  }, [sessionId, refresh]);

  const isVote = info?.lookup_key?.startsWith("vote_");

  return (
    <div className="flex min-h-screen items-center justify-center bg-obsidian px-4">
      <div className="glass-strong w-full max-w-md rounded-2xl p-10 text-center" data-testid="payment-result">
        <Crown className="mx-auto mb-4 h-8 w-8 text-gold" />
        {state === "checking" && (<><Loader2 className="mx-auto mb-4 h-10 w-10 animate-spin text-gold" /><h1 className="text-2xl text-amber-50">Confirming your payment…</h1><p className="mt-2 text-sm text-amber-100/60">This takes just a moment.</p></>)}
        {state === "paid" && (<><CheckCircle2 className="mx-auto mb-4 h-12 w-12 text-emerald-accent" /><h1 className="text-3xl text-amber-50">Thank you!</h1><p className="mt-2 text-amber-100/70">{isVote ? "Your vote credits have been added to your account." : "Your generous support has been received."}</p><div className="mt-6 flex justify-center gap-3"><Link to={isVote ? "/vote" : "/support"} className="btn-gold">{isVote ? "Start Voting" : "Back to Support"}</Link><Link to="/account" className="btn-ghost-gold">My Account</Link></div></>)}
        {state === "failed" && (<><XCircle className="mx-auto mb-4 h-12 w-12 text-red-400" /><h1 className="text-2xl text-amber-50">Payment not confirmed</h1><p className="mt-2 text-sm text-amber-100/60">If you were charged, it will reflect shortly. Otherwise please try again.</p><Link to="/vote" className="btn-ghost-gold mt-6 inline-block">Back</Link></>)}
      </div>
    </div>
  );
}
